import { render, staticRenderFns } from "./PaymentProcessVoucherCandle.vue?vue&type=template&id=25908c8d&"
import script from "./PaymentProcessVoucherCandle.vue?vue&type=script&lang=js&"
export * from "./PaymentProcessVoucherCandle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports